import { Component } from '@angular/core';
import { AuthService } from './services/auth/auth.service';
import { Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = environment.softwareName;

  constructor(
    private authService: AuthService,
    private config: PrimeNGConfig,
    private message: MessageService,
    private router: Router
  ) {}

  get isLoggedIn() {
    return this.authService.isLogged();
  }

  ngOnInit() {
    // Sessione non più recuperabile fuori da una chiamata HTTP (rinnovo automatico fallito,
    // logout fatto da un'altra scheda): si torna al login
    this.authService.sessionExpired$.subscribe(() => {
      this.message.add({
        id: 1000,
        severity: 'error',
        summary: 'Sessione scaduta',
        detail: "La tua sessione è scaduta, rieffettuare l'accesso.",
        life: 2000,
      });
      this.authService.logout();
      this.router.navigateByUrl('/login');
    });

    this.config.setTranslation({
      accept: 'Ok',
      reject: 'Annulla',
      dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
      dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
      dayNamesMin: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
      monthNames: [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre',
        'Dicembre',
      ],
      monthNamesShort: [
        'Gen',
        'Feb',
        'Mar',
        'Apr',
        'Mag',
        'Giu',
        'Lug',
        'Ago',
        'Set',
        'Ott',
        'Nov',
        'Dic',
      ],
    });
  }
}
